import { add, format } from 'date-fns';
import { memo } from 'react';

interface PlannerDateHeaderProps {
  start: Date;
  days: number;
}

/**
 * PlannerDateHeader - Sticky date header for each column.
 * Memoized to prevent re-renders on scroll since start and days
 * remain stable for each column.
 */
export const PlannerDateHeader = memo(function PlannerDateHeader({
  start,
  days,
}: PlannerDateHeaderProps) {
  const date = add(start, { days });
  return (
    <header className='sticky top-0 flex h-14 flex-col items-center justify-center border-b border-outline-variant bg-white transition-all duration-200'>
      <p>{format(date, 'EEEEEE dd')}</p>
      <p className='text-xs font-light text-grey-50'>{format(date, 'MMM')}</p>
    </header>
  );
});

PlannerDateHeader.displayName = 'PlannerDateHeader';
